import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageContext } from '@hero/web-context';
import { WalletPageContainer } from '@/components/features/Wallet/WalletPageContainer';

export default function DashboardWallet() {
  const { t } = useTranslation(['dashboard', 'm-payment']);
  const { setPageName } = usePageContext();

  useEffect(() => {
    setPageName(t('m-payment:wallet.page_title'));
  }, [setPageName, t]);

  return <WalletPageContainer />;
}
